var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));

var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));

var style = createStyles_1.default(function (_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k;

  var opacity = _a.opacity,
      palette = _a.palette,
      shape = _a.shape,
      sizes = _a.sizes,
      typography = _a.typography;

  var boxShadow = function boxShadow(_a) {
    var _b, _c, _d;

    var state = _a.state;

    if (state === "error") {
      return ((_b = palette === null || palette === void 0 ? void 0 : palette.error) === null || _b === void 0 ? void 0 : _b.main) + " 0 0 2px";
    }

    if (state === "success") {
      return ((_c = palette === null || palette === void 0 ? void 0 : palette.success) === null || _c === void 0 ? void 0 : _c.main) + " 0 0 1px";
    }

    return ((_d = palette === null || palette === void 0 ? void 0 : palette.text) === null || _d === void 0 ? void 0 : _d.hint) + " 0 0 0 1px";
  };

  return {
    disabled: {
      "& [disabled], & [disabled]:focus, & [disabled]:hover": {
        boxShadow: ((_b = palette === null || palette === void 0 ? void 0 : palette.text) === null || _b === void 0 ? void 0 : _b.hint) + " 0 0 0 1px",
        color: (_c = palette === null || palette === void 0 ? void 0 : palette.text) === null || _c === void 0 ? void 0 : _c.hint,
        opacity: opacity === null || opacity === void 0 ? void 0 : opacity.opaque,
        "&::placeholder": {
          color: (_d = palette === null || palette === void 0 ? void 0 : palette.text) === null || _d === void 0 ? void 0 : _d.secondary
        }
      }
    },
    focused: {
      "& input:not(:read-only)": {
        boxShadow: ((_e = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _e === void 0 ? void 0 : _e.main) + " 0 0 0 2px"
      }
    },
    input: __assign(__assign({}, typography.body2), {
      backgroundColor: "transparent",
      border: sizes === null || sizes === void 0 ? void 0 : sizes.none,
      borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
      boxShadow: boxShadow,
      boxSizing: "border-box",
      color: (_f = palette === null || palette === void 0 ? void 0 : palette.text) === null || _f === void 0 ? void 0 : _f.primary,
      flex: "1 1 100%",
      lineHeight: (sizes === null || sizes === void 0 ? void 0 : sizes.standard) + "px",
      minHeight: sizes === null || sizes === void 0 ? void 0 : sizes.mediumX,
      outline: "none",
      padding: sizes === null || sizes === void 0 ? void 0 : sizes.small,
      paddingRight: function paddingRight(_a) {
        var hasIcon = _a.hasIcon;
        return hasIcon ? sizes === null || sizes === void 0 ? void 0 : sizes.large : sizes === null || sizes === void 0 ? void 0 : sizes.small;
      },
      width: "100%",
      "&:hover:not(:read-only):not(:disabled):not(:focus)": {
        boxShadow: ((_g = palette === null || palette === void 0 ? void 0 : palette.text) === null || _g === void 0 ? void 0 : _g.secondary) + " 0 0 0 1px"
      },
      "&::placeholder": {
        color: (_h = palette === null || palette === void 0 ? void 0 : palette.text) === null || _h === void 0 ? void 0 : _h.secondary
      },
      "&::-ms-clear": {
        display: "none",
        height: sizes === null || sizes === void 0 ? void 0 : sizes.none,
        width: sizes === null || sizes === void 0 ? void 0 : sizes.none
      },

      /**
       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/:placeholder-shown
       */
      "&:placeholder-shown": {
        boxShadow: boxShadow
      },
      "&:not(:placeholder-shown)": {
        boxShadow: ((_j = palette === null || palette === void 0 ? void 0 : palette.text) === null || _j === void 0 ? void 0 : _j.primary) + " 0 0 0 1px"
      }
    }),
    inputMultiline: {
      resize: "vertical"
    },
    inputTypeSearch: {
      "&::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
        display: "none"
      }
    },
    root: {
      display: "flex",
      flexFlow: "column nowrap",
      padding: sizes === null || sizes === void 0 ? void 0 : sizes.none,
      "& svg, & .natds-icons": {
        fill: (_k = palette === null || palette === void 0 ? void 0 : palette.text) === null || _k === void 0 ? void 0 : _k.primary
      }
    }
  };
});
exports.useStyles = makeStyles_1.default(style, {
  name: "NatDSInput"
});